import * as React from 'react'

type ComponentType = {
  ids: number[]
  name: string
}
type PageContext = {
  pageContext: {
    components: ComponentType[]
  }
}

const VisorComponents = ({ pageContext: { components } }: PageContext) => {

  const [type, setType] = React.useState<ComponentType>()
  const [id, setId] = React.useState<number>()

  const handleTypeChange = (e: any) => {
    setType(components.find((element) => element.name === e.target.value))
  }
  const handleIdChange = (e: any) => {
    setId(e.target.value)
  }

  return (
    <div className="py-5 d-flex flex-column align-items-center">
      <select
        onChange={handleTypeChange}
        name="select-types"
        id="select-types"
        style={{padding:"10px 15px",border:"1px solid #ccc",marginBottom:"10px"}}
      >
        <option value="">Tipo de componente</option>
        {components.map((component, index) => (
          <option
            key={index}
            value={component.name}
          >
            {component.name}
          </option>
        ))}
      </select>
      <select
        onChange={handleIdChange}
        style={{padding:"10px 15px",border:"1px solid #ccc",marginBottom:"10px"}}
        name="select-id"
        id="select-id"
      >
        <option value="">Id del componente</option>
        {type?.ids
          .sort((a, b) => a - b)
          .map((id_component, index) => (
            <option
              key={index}
              value={id_component}
            >
              {id_component}
            </option>
          ))}
      </select>
      {type && id ? <>Visualizalo en: <a target='_blank' href={`/component/?type=${type?.name}&id=${id}`}>{`/component/?type=${type?.name}&id=${id}`}</a></> :''}
      {type && id ? (
        <a
          style={{ transform: 'scale(0.7)' }}
          target="_blank"
          className="w-100 d-flex justify-content-center"
          href={`/component/?type=${type.name}&id=${id}`}
        >
          <iframe
            className="scaled-iframe"
            style={{
              border: '2px solid #ccc',
              borderRadius: '5px',
              width: '1920px',
              height: '1080px',
            }}
            src={`/component/?type=${type.name}&id=${id}`}
          ></iframe>
        </a>
      ) : (
        ''
      )}
    </div>
  )
}

export default VisorComponents

export { Head } from '@components/Head'
